exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".txt-error {\n    color: #ff0039;\n    font-size: 12px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/compras/proveedor-edit/proveedor-edit.component.css
// module id = ../../../../../src/app/components/compras/proveedor-edit/proveedor-edit.component.css
// module chunks = main